<template>
  <div class="user_list_page">

    <business-group 
      v-if="isDeviceModelsLoaded"
      :tableConfig="tableConfig" 
      :formConfig="{ ...formConfig }" 
      :formValues="dynamicFormValues"
      ref="businessGroup"
    >
      <!-- 表格上方操作按钮 -->
      <template #tableAction>
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div>
            <a-button type="primary" @click="handleExportExcel" icon="download">
              导出Excel
            </a-button>
          </div>
        </div>
      </template>
      
      <!-- 查询表单插槽 -->
      <template #formSlot>
        <a-form-item>
          <a-select 
            placeholder="请选择设备型号" 
            v-decorator="['deviceModel']"
            style="width: 250px; margin-right: 10px; vertical-align: middle" 
            allowClear
          >
            <a-select-option v-for="model in deviceModels" :key="model.deviceModel"
              :value="model.deviceModel">
              <span style="display: inline-block; width: 80px;">{{ model.modelName }}</span>
              <span>{{ model.deviceDescription }}</span>
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-input placeholder="请输入邮箱" v-decorator="['email']"
            style="width: 200px; margin-right: 10px; vertical-align: middle" />
        </a-form-item>
        <a-form-item>
          <a-input placeholder="请输入DIY名称" v-decorator="['name']"
            style="width: 200px; margin-right: 10px; vertical-align: middle" />
        </a-form-item>
        <a-form-item>
          <a-select placeholder="请选择DIY来源" v-decorator="['classification']"
            style="width: 200px; margin-right: 10px; vertical-align: middle" allowClear>
            <a-select-option value="1">默认</a-select-option>
            <a-select-option value="2">AI</a-select-option>
            <a-select-option value="3">分享</a-select-option>
            <a-select-option value="4">纯蓝牙</a-select-option>
          </a-select>
        </a-form-item>
      </template>

      <!-- 创建时间格式化 -->
      <template #createTime="record">
        {{ dataFormatStr(record.createTime, "YYYY-MM-DD HH:mm:ss") }}
      </template>

      <!-- DIY图标格式化 -->
      <template slot="icon" slot-scope="record">
        <img width="30" :src="record.icon" />
      </template>

      <!-- DIY来源格式化 -->
      <template slot="classification" slot-scope="record">
        {{ formatClassification(record.classification) }}
      </template>

    </business-group>

  </div>
</template>

<script>
import pageTitle from "@/components/business/pageTitle";
import businessGroup from "@/components/business/businessGroup";
import { tips } from "@/utils/util";
import { formatToStr } from "@/utils/dateUtils";

export default {
  components: {
    pageTitle,
    businessGroup
  },
  data() {
    return {
      tableConfig: {
        url: "bluetoothlight/web/router/neewerhome/manage/device/diySetting/pages",
        rowKey: "id",
        columns: [
          {
            title: "ID",
            dataIndex: "id",
            key: "id",
            align: "center",
            ellipsis: true,
            width: 80
          },
          {
            title: "型号名称",
            dataIndex: "modelName",
            key: "modelName",
            align: "center",
            ellipsis: true,
            width: 120
          },
          {
            title: "设备类型",
            dataIndex: "deviceType",
            key: "deviceType",
            align: "center",
            ellipsis: true,
            width: 100
          },
          {
            title: "设备型号",
            dataIndex: "deviceModel",
            key: "deviceModel",
            align: "center",
            ellipsis: true,
            width: 100
          },
          {
            title: "DIY名称",
            dataIndex: "name",
            key: "name",
            align: "center",
            ellipsis: true,
            width: 150
          },
          {
            title: "图标",
            key: "icon",
            align: "center",
            ellipsis: true,
            scopedSlots: { customRender: "icon" },
            width: 100
          },
          {
            title: "DIY来源",
            key: "classification",
            align: "center",
            ellipsis: true,
            scopedSlots: { customRender: "classification" },
            width: 100
          },
          {
            title: "创建时间",
            key: "createTime",
            scopedSlots: { customRender: "createTime" },
            align: "center",
            width: 160
          }
        ]
      },
      formConfig: {
        timeShow: false,
        formShow: true
      },
      deviceModels: [], // 设备型号选项数组
      formValues: {}, // 额外的查询参数
      isDeviceModelsLoaded: false // 设备型号是否已加载完成
    };
  },
  computed: {
    // 动态生成表单查询参数
    dynamicFormValues() {
      return { ...this.formValues };
    }
  },
  mounted() {
    // 获取设备型号列表
    this.fetchDeviceModels();
  },
  methods: {
    // 刷新
    refreshData() {
      this.$refs?.["businessGroup"]?.getData?.();
    },
    // 获取设备型号列表
    async fetchDeviceModels() {
      try {
        const result = await this.$get("bluetoothlight/web/router/neewerhome/manage/device/classification/get");
        if (result?.resultStatus && result.resultData) {
          this.deviceModels = result.resultData;
          // 注意：不再默认选中第一个设备型号
        } else {
          console.warn("获取设备型号列表为空或失败");
        }
      } catch (error) {
        console.error("获取设备型号失败:", error);
        tips(this, false, "获取设备型号失败");
      } finally {
        // 无论成功与否，都标记为已加载，触发表格渲染
        this.isDeviceModelsLoaded = true;
      }
    },
    // 时间格式化
    dataFormatStr(ret, format) {
      if (!ret) {
        return "";
      }
      if (!format) {
        format = "YYYY-MM-DD HH:mm:ss";
      }
      return formatToStr(ret, format);
    },
    // DIY来源格式化
    formatClassification(classification) {
      if (!classification) {
        return '';
      }
      const classificationMap = {
        '1': '默认',
        '2': 'AI',
        '3': '分享',
        '4': '纯蓝牙'
      };
      return classificationMap[classification] || classification;
    },
    // Excel导出
    async handleExportExcel() {
      // 获取表单实例
      const formInstance = this.$refs.businessGroup?.form;
      if (!formInstance) {
        tips(this, false, "表单未初始化");
        return;
      }

      // 获取表单字段值
      const email = formInstance.getFieldValue('email');
      const deviceModel = formInstance.getFieldValue('deviceModel');
      const name = formInstance.getFieldValue('name');
      const classification = formInstance.getFieldValue('classification');

      // 校验必填字段
      if (!email) {
        tips(this, false, "请输入邮箱");
        return;
      }
      if (!deviceModel) {
        tips(this, false, "请选择设备型号");
        return;
      }

      // 根据选中的设备型号查找对应的设备类型
      const selectedModelObj = this.deviceModels.find(model => model.deviceModel === deviceModel);
      if (!selectedModelObj || !selectedModelObj.deviceType) {
        tips(this, false, "无法获取设备类型，请重新选择设备型号");
        return;
      }
      const deviceType = selectedModelObj.deviceType;

      try {
        // 构建导出参数
        const params = {
          email: email,
          deviceType: deviceType,
          deviceModel: deviceModel
        };
        
        // 如果填写了DIY名称，添加到参数中
        if (name) {
          params.name = name;
        }
        
        // 如果选择了DIY来源，添加到参数中
        if (classification) {
          params.classification = classification;
        }

        console.log('导出参数:', params);

        // 调用后端导出接口获取文件URL
        const response = await this.$post(
          'bluetoothlight/web/router/neewerhome/manage/device/diySetting/exportExcel',
          params
        );

        console.log('后端响应:', response);

        // 检查响应中是否包含文件链接
        if (!response || !response.resultData) {
          throw new Error('未获取到文件下载链接');
        }

        // 获取文件下载链接
        const fileUrl = response.resultData;
        console.log('文件下载链接:', fileUrl);

        // 创建隐藏的下载链接
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = 'DIY设置数据.xlsx';
        link.style.display = 'none';

        // 触发下载
        document.body.appendChild(link);
        link.click();

        // 清理
        setTimeout(() => {
          document.body.removeChild(link);
        }, 100);

        tips(this, true, '导出成功');
      } catch (error) {
        console.error('导出失败:', error);
        
        // 提供更明确的错误提示
        if (error.code === 'ECONNABORTED') {
          tips(this, false, '导出超时，请检查网络连接');
        } else if (error.response) {
          tips(this, false, `导出失败：${error.response.status} ${error.response.statusText}`);
        } else {
          tips(this, false, '导出失败：' + (error.message || '未知错误'));
        }
      }
    }
  }
};
</script>

<style scoped>
.user_list_page {
  padding: 20px;
}
</style>
